import { useMutation, useQuery } from "@tanstack/react-query";
import {
  addons,
  couponApply,
  createPayment,
  featuresList,
  myplans,
  paymentCallback,
  paymentStatus,
  planlist,
} from "api/plans";

export const usePlansList = ({ plan_type, see_all }, options = {}) => {
  return useQuery({
    queryKey: ["plans-list", { plan_type, see_all }],
    queryFn: planlist,
    ...options,
  });
};

export const useMyPlans = (options = {}) => {
  return useQuery({
    queryKey: ["my_plans"],
    queryFn: myplans,
    ...options,
  });
};

export const useAddOns = (options = {}) => {
  return useQuery({
    queryKey: ["add-ons"],
    queryFn: () => addons(options.params),
    ...options,
  });
};

export const useCreatePlan = (options = {}) => {
  return useMutation({
    mutationFn: createPayment,
    onSuccess: (data, variables, context) => {
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const usePaymentCallback = (txnid, coupon_id, options = {}) => {
  return useQuery({
    queryKey: ["callback", txnid, coupon_id],
    queryFn: () => paymentCallback(txnid, coupon_id),
    enabled: !!txnid,
    ...options,
  });
};

export const usePaymentStatus = (options = {}) => {
  return useMutation({
    mutationFn: paymentStatus,
    onSuccess: (data, variables, context) => {
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const useCouponApply = (options = {}) => {
  return useMutation({
    mutationFn: couponApply,
    onSuccess: (data, variables, context) => {
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const useFeatureList = (plan_type, options = {}) => {
  return useQuery({
    queryKey: ["feature_list", plan_type],
    queryFn: () => featuresList(plan_type),
    enabled: !!plan_type,
    ...options,
  });
};
